import { FiClock } from 'react-icons/fi';

export const GlobalSearchInitialState = ({ recentSearches, onClearRecent, onSearch }) => (
  <section className="p-3">
    {recentSearches.length > 0 && (
      <section className="mb-3">
        <header className="flex items-center justify-between px-2 mb-1">
          <p className="text-xs font-medium text-black flex items-center gap-1">
            <FiClock className="text-sm" /> Recent Searches
          </p>
          <button
            type="button"
            onClick={onClearRecent}
            className="text-[10px] text-red-500 hover:underline"
          >
            Clear All
          </button>
        </header>
        <ul className="flex flex-wrap gap-2 px-2 list-none">
          {recentSearches.map((term, i) => (
            <li key={`${term}-${i}`}>
              <button
                type="button"
                onClick={() => onSearch(term)}
                className="text-xs bg-gray-100 hover:bg-orange-50 text-black px-3 py-1.5 rounded-full transition border hover:border-orange-300"
              >
                {term}
              </button>
            </li>
          ))}
        </ul>
      </section>
    )}
  </section>
);
